"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import { Flex, Text, Box, NumberInput as ChakraNumberInput, NumberInputField as ChakraNumberInputField, forwardRef, } from "@chakra-ui/react";
import { InputVariant, FieldHelpText, FieldTitle } from "../Input";
import { getLabelHoverColor } from "../../helpers";
const INPUT_HEIGHT = 48;
const NumberInput = forwardRef((_a, ref) => {
    var _b, _c;
    var { title, helpText, helpTextIcon, disabled = false, variant = InputVariant.FILLED, verticalDisplay = false, value, mandatory = false, unit = "" } = _a, rest = __rest(_a, ["title", "helpText", "helpTextIcon", "disabled", "variant", "verticalDisplay", "value", "mandatory", "unit"]);
    const unitRef = useRef(null);
    const [size, setSize] = useState({ width: 0, height: 0 });
    useEffect(() => {
        if (unitRef.current) {
            const rect = unitRef.current.getBoundingClientRect();
            setSize({ width: rect.width, height: rect.height });
        }
    }, [unitRef]);
    const HelpTextComponent = useMemo(() => (_jsx(Box, Object.assign({ pb: verticalDisplay ? 1 : 0, pt: 1 }, { children: _jsx(FieldHelpText, { text: helpText, icon: helpTextIcon, variant: variant, disabled: disabled }) }))), [verticalDisplay, helpText, helpTextIcon, variant, disabled]);
    const LabelHelpTextComponent = useMemo(() => (_jsxs(_Fragment, { children: [title && (_jsx(FieldTitle, { title: title, mandatory: variant !== InputVariant.READONLY ? false : mandatory, disabled: disabled, variant: variant })), variant !== InputVariant.READONLY &&
                !verticalDisplay &&
                helpText &&
                HelpTextComponent] })), [
        disabled,
        helpText,
        mandatory,
        title,
        variant,
        verticalDisplay,
        HelpTextComponent,
    ]);
    return (_jsxs(Flex, Object.assign({ direction: verticalDisplay ? "column" : "row-reverse", justifyContent: "space-between", px: "2", py: "4", sx: {
            ".number-input:hover + div > label": {
                color: getLabelHoverColor(disabled, variant),
            },
        } }, { children: [verticalDisplay && LabelHelpTextComponent, variant !== InputVariant.READONLY ? (_jsxs(Box, Object.assign({ position: "relative" }, { children: [_jsx(ChakraNumberInput, Object.assign({ ref: ref, className: "number-input", variant: variant, value: value, disabled: disabled, w: verticalDisplay ? "100%" : 24 }, rest, { children: _jsx(ChakraNumberInputField, { paddingRight: `${((_b = size === null || size === void 0 ? void 0 : size.width) !== null && _b !== void 0 ? _b : 0) + 16}px` }) })), unit && (_jsx(Box, Object.assign({ sx: {
                            position: "absolute",
                            right: 3,
                            top: `${(INPUT_HEIGHT - ((_c = size === null || size === void 0 ? void 0 : size.height) !== null && _c !== void 0 ? _c : 0)) / 2}px`,
                        }, ref: unitRef }, { children: _jsx(Text, Object.assign({ variant: "title.mobileCard" }, { children: unit })) })))] }))) : (_jsxs(Text, Object.assign({ as: "span", variant: "body.largeDemibold", color: "semantic.text.primary" }, { children: [value, unit] }))), !verticalDisplay && (_jsx(Flex, Object.assign({ direction: "column", pr: "4", justifyContent: "center" }, { children: LabelHelpTextComponent }))), verticalDisplay && variant !== InputVariant.READONLY && helpText && (_jsx(Flex, Object.assign({ direction: "column", justifyContent: "center" }, { children: HelpTextComponent })))] })));
});
NumberInput.displayName = "NumberInput";
export default NumberInput;
//# sourceMappingURL=NumberInput.js.map